<template>
  <div class="header-wrapper">
    <header id="header">
      <a :href="hostWebsite" class="logo"><img src="/Application/Home/Resource/static/images/logo.png" alt=""></a>
      <router-link to="/evaluation" class="evaluation-button">预约专业评估<icon icon-class="navigation-arrow"></icon></router-link>
      <!-- <div class="header-menu-icon" @click="menuShow = !menuShow">
        <div class="menu" :class="{'open': menuShow}">
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </div>
      </div> -->
    </header>
    <div class="header-menu">
      <ul class="index-menu" @click.stop="">
        <li class="menu-item" :class="{'active': currentActive == 'index'}"><router-link to="/" @click.native="menuShow = false">首页</router-link></li>
        <li class="menu-item" :class="{'active': currentActive == 'lecturer'}"><router-link to="/lecturer" @click.native="menuShow = false">师资</router-link></li>
        <li class="menu-item" :class="{'active': currentActive == 'course'}"><router-link to="/course" @click.native="menuShow = false">设计室Studio</router-link></li>
        <li class="menu-item" :class="{'active': currentActive == 'achievement'}"><router-link to="/achievement" @click.native="menuShow = false">案例</router-link></li>
        <li class="menu-item" :class="{'active': currentActive == 'article'}"><router-link to="/article" @click.native="menuShow = false">专题</router-link></li>
        <!-- <li class="menu-item" :class="{'active': currentActive == 'book'}"><router-link to="/book" @click.native="menuShow = false">新设计书</router-link></li> -->
      </ul>
    </div>
    <!-- <transition name="menu" appear>
      <div class="menu-list-wrapper" v-show="menuShow" @click="menuShow = false">
        <ul class="index-menu" @click.stop="">
          <li class="menu-item" :class="{'active': currentActive == 'index'}"><router-link to="/" @click.native="menuShow = false">首页</router-link></li>
          <li class="menu-item" :class="{'active': currentActive == 'course'}"><router-link to="/course" @click.native="menuShow = false">课程</router-link></li>
          <li class="menu-item" :class="{'active': currentActive == 'lecturer'}"><router-link to="/lecturer" @click.native="menuShow = false">师资</router-link></li>
          <li class="menu-item" :class="{'active': currentActive == 'achievement'}"><router-link to="/achievement" @click.native="menuShow = false">成果</router-link></li>
          <li class="menu-item" :class="{'active': currentActive == 'article'}"><router-link to="/article" @click.native="menuShow = false">干货</router-link></li>
          <li class="menu-item" :class="{'active': currentActive == 'book'}"><router-link to="/book" @click.native="menuShow = false">新设计书</router-link></li>
        </ul>
      </div>
    </transition> -->

  </div>
</template>

<style lang="less" scoped>
.header-wrapper{
  width: 100%;
  height: 87px;
}
#header{
  width: 100%;
  height: 48px;
  position: fixed;
  top: 0;
  left: 0;
  // box-shadow: 0px 2px 6px 0px rgba(207, 207, 207, 0.44);
  background: #FFF;
  padding: 0 10px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 999;
  img{
    height: 28px;
  }
  .evaluation-button{
    width: 108px;
    height: 32px;
    background: linear-gradient(270deg, #2B7CEB 0%, #58BAEA 100%);
    border-radius: 32px;
    color: #FFF;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    svg{
      position: relative;
      font-weight: bold;
      margin-left: 6px;
    }
  }
  .menu{
    position: relative;
    height: 24px;
    width: 24px;
    padding: 5px 2px;
    &.open{
      .bar{
        &:nth-of-type(1) {
          transform: translateY(6px) rotate(45deg);
        }
        &:nth-of-type(2) {
          opacity: 0;
        }
        &:nth-of-type(3) {
          transform: translateY(-6px) rotate(-45deg);
        }
      }
    }
    .bar{
      height: 2px;
      width: 20px;
      margin: 4px auto;
      background-color: #000;
      border-radius: 10px;
      transition: .4s;
      &:first-child{
        margin-top: 0;
      }
    }
  }
}
.header-menu{
  width: 100%;
  height: 39px;
  position: fixed;
  top: 48px;
  left: 0;
  border-top: 1px solid #EEE;
  background: #FFF;
  box-shadow: 0px 2px 6px 0px rgba(207, 207, 207, 0.44);
  z-index: 999;
  .index-menu{
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .menu-item{
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      &.active{
        &::after{
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 2px;
          border-radius: 1px;
          background: @cano;
        }
        a{
          color: #333;
          font-weight: bold;
        }
      }
      a{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #666;
      }
    }
  }
}
.menu-list-wrapper{
  position: fixed;
  top: 48px;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.4);
  color: #333;
  transition: .3s;
  z-index: 999;
  .index-menu{
    width: 100%;
    padding: 4px 0 12px;
    background: #FFF;
    transition: .3s;
    .menu-item{
      width: 100%;
      padding: 12px 0;
      line-height: 20px;
      font-size: 14px;
      color: #666;
      display: flex;
      justify-content: center;
      align-items: center;
      &.active a{
        color: @cano;
      }
      a{
        color: #666;
      }
    }
  }
}
// 动画
.menu-enter,
.menu-leave-active {
  opacity: 0;
}
.menu-enter .index-menu,
.menu-leave-active .index-menu{
  transform: translateY(-20px);
}
</style>

<script>
  export default {
    data() {
      return {
        hostWebsite: 'https://www.canopyu.com',
        menuShow: false,
      }
    },
    computed: {
      currentActive() {
        return this.$store.state.currentMenu;
      }
    },
    created() {
      this.hostWebsite = window.location.origin
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/header.vue